import React from "react";
import { Integration } from "../../models/Entities";
import { APIRequestLogEntryIntegration } from "../pages/IntegrationsManagementEntities";
import { Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";

interface Props {
  textVariant?: React.ComponentProps<typeof Text>["variant"];
  integration: Integration | APIRequestLogEntryIntegration;
  customText?: string;
  isMuted?: boolean;
}

const IntegrationNameAndLogo = ({ textVariant, integration, customText, isMuted }: Props) => {
  return (
    <div className="flex flex-row items-center min-w-0 whitespace-nowrap gap-x-1">
      <div
        className={clsx(
          "flex shrink-0 items-center justify-center h-6 w-6 box-border p-0.5 overflow-hidden rounded-full bg-white",
          isMuted && "opacity-50",
        )}
      >
        {integration.square_image ? (
          <img
            src={integration.square_image}
            alt=""
            className="block h-full w-full object-contain"
          />
        ) : (
          <span aria-hidden="true" className="font-semibold text-base">
            {(integration.abbreviated_name || integration.name)?.charAt(0).toUpperCase()}
          </span>
        )}
      </div>
      <div className="truncate">
        <Text
          as="span"
          className={clsx("block", isMuted && "text-gray-40")}
          variant={textVariant || "md"}
        >
          {customText || integration.abbreviated_name
            ? integration.abbreviated_name
            : integration.name}
        </Text>
      </div>
    </div>
  );
};

export default IntegrationNameAndLogo;
